<template>
  <div class="container">
    <div class="processItem" v-for="p in dataArr" :key="p.num + 1">
      <p class="firstLine">
        <i
          class="el-icon-success"
          :class="{ 'el-icon-warning': p.status === 2 || p.status === 3 }"
        ></i>
        <span class="userTitle">{{ p.taskName }}</span>
        <span
          class="line"
          :class="{ 'line-reject': p.status === 2 || p.status === 3 }"
          v-if="p.num + 1 !== dataArr.length"
        />
      </p>
      <p class="secondLine">
        <span class="username">{{ p.approver }}</span>
        <span
          class="status"
          :class="{ 'status-reject': p.status === 2 || p.status === 3 }"
        >
          {{ p.statusStr }}
        </span>
      </p>
      <p class="time">{{ p.createTime }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'r-process',
  data() {
    return {}
  },
  props: {
    dataArr: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  display: flex;
  height: 190px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  .processItem {
    margin-right: 8px;
    min-height: 62px;
    .firstLine {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 8px;
      .userTitle {
        font-size: 14px;
        color: #3a3f63;
        font-weight: 700;
        margin-right: 8px;
      }
      .line {
        display: inline-block;
        width: 93px;
        height: 2px;
        background: #00d0b5;
      }
      .line-reject {
        background-color: #ffb243;
      }
      .el-icon-success {
        color: #00d0b5;
        margin-right: 8px;
      }
      .el-icon-warning {
        color: #ffb243;
        margin-right: 8px;
      }
    }
    .secondLine {
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      .username {
        font-size: 12px;
        margin-right: 8px;
      }
      .status {
        display: inline-block;
        width: 64px;
        height: 18px;
        background: #00d0b5;
        border-radius: 8px;
        font-size: 12px;
        text-align: center;
        line-height: 18px;
        color: white;
      }
      .status-reject {
        background-color: #ffb243;
      }
    }
    .time {
      font-size: 12px;
      color: #858ebd;
    }
  }
}
</style>
